import { memo, Suspense, useCallback } from "react";
import { Route, Routes } from "react-router-dom";
import { PublicRoute } from "./PublicRoute";
import { AppRoutesProps, routeConfig } from "../config/routeConfig";
import { ProtectedRoute } from "@/zapi-frontend/app/providers/router/ui/ProtectedRoute";
import { NonProtectedRoute } from "@/zapi-frontend/app/providers/router/ui/NonProtectedRoute";

const AppRouter = () => {
  // const { pathname } = useLocation();
  // const privacyNoticeRoute = getRoutePrivacyNotice();
  // const termsAndConditionsRoute = getRouteTermsOfUse();
  // const weAreDeployingRoute = getRouteWeAreDeploying();
  // const isPrivacyOrTermsPage = pathname === privacyNoticeRoute || pathname === termsAndConditionsRoute;
  // const shouldRedirect = import.meta.env.VITE_REDIRECT_ALL_ROUTES === "true";

  const renderWithWrapper = useCallback((route: AppRoutesProps) => {
    const element = (
      <Suspense fallback={<div>Loading...</div>}>
        {route.element}
        {/* {!isPrivacyOrTermsPage && <Footer />} */}
      </Suspense>
    );

    // for now we are using public route for all routes
    switch (route.routePrivilege) {
      case "protected":
        return (
          <Route
            key={route.path}
            path={route.path}
            element={<ProtectedRoute roleAccess={route.roleAccess}>{element}</ProtectedRoute>}
          />
        );
      case "nonprotected":
        return <Route key={route.path} path={route.path} element={<NonProtectedRoute>{element}</NonProtectedRoute>} />;
      case "public":
      default:
        return <Route key={route.path} path={route.path} element={<PublicRoute>{element}</PublicRoute>} />;
    }
  }, []);

  // if (shouldRedirect) {
  //   return (
  //     <Routes>
  //       <Route path="*" element={<Navigate to={weAreDeployingRoute} replace />} />
  //       <Route
  //         path={weAreDeployingRoute}
  //         element={
  //           <PublicRoute>
  //             <WeAreDeployingPage />
  //           </PublicRoute>
  //         }
  //       />
  //     </Routes>
  //   );
  // }

  return <Routes>{Object.values(routeConfig).map(renderWithWrapper)}</Routes>;
};

export default memo(AppRouter);
